import { useSelector } from 'react-redux';
import useApi from '../base/useApi';
import { toast } from 'react-hot-toast';
import { Error } from '../../../modules/alerts';

export default function useUpdateMentorSettings() {
  const auth = useSelector((state) => state.auth.data);
  const api = useApi();

  const extractErrorFromResponse = (response) => {
    let msg = [];
    Object.keys(response).forEach((key) => {
      msg.push(`${key} - ${response[key]}`);
    });

    return msg.join(',');
  };

  const handleUpdateSettings = async (
    mentor,
    data,
    notify = true,
    isForm = false
  ) => {
    const endpoint = `/api/ai-mentor/orgs/${auth?.tenant?.key}/users/${auth?.user?.user_nicename}/mentors/${mentor?.unique_id}/settings/`;
    const response = await api.put(endpoint, data, isForm);
    if (response?.data) {
      if (notify) {
        toast.success('Mentor has been updated!');
      }
      return response?.data;
    } else {
      if (notify) {
        let errorMessage = null;
        try {
          const responseError = JSON.parse(response?.error);
          errorMessage = responseError?.error || response?.detail;
          if (!errorMessage) {
            errorMessage = extractErrorFromResponse(responseError);
          }
        } catch (e) {
          errorMessage = response;
        }
        toast.custom(Error(errorMessage));
      }
    }
  };

  return { handleUpdateSettings };
}
